import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/views/home.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/product-img",
    name: "ProductImg",
    component: () => import("@/views/product_img.vue"),
    meta: {
      keepAlive: true,
      scrollTop: 0,
    }
  },
  {
    path: "/product-info",
    name: "ProductInfo",
    component: () => import("@/views/product_info.vue"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/admin",
    name: "Admin",
    redirect: '/admin/admin-home',
    component: () => import("@/views/admin.vue"),
    children: [
      {
        path: 'admin-home',
        component: () => import("@/views/admin-home.vue"),
      },
      {
        path: 'admin-img',
        component: () => import("@/views/admin-img.vue"),
      },
      {
        path: 'img-info',
        component: () => import("@/views/img-info.vue"),
      },
    ]
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js